import { render, staticRenderFns } from "./public_img.vue?vue&type=template&id=3c15f1b4&"
import script from "./public_img.vue?vue&type=script&lang=js&"
export * from "./public_img.vue?vue&type=script&lang=js&"
import style0 from "./public_img.vue?vue&type=style&index=0&id=3c15f1b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports